export function parseTypes(type: string): 'string' | 'date' | 'number' | 'boolean' | 'datetime' {
  let result: 'string' | 'date' | 'number' | 'boolean' | 'datetime' = 'string';
  switch (type.toLowerCase()) {
    case 'string':
      result = 'string';
      break;
    case 'boolean':
      result = 'boolean';
      break;
    case 'datetime':
    case 'date':
      result = 'date';
      break;
    case 'int':
    case 'int16':
    case 'int32':
    case 'int64':
    case 'decimal':
    case 'float':
    case 'number':
    case 'single':
      result = 'number';
      break;

  }
  return result;
}
